import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles((theme) => ({
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  pickercontainer: {
    maxWidth: "100%",
    border: "1px dashed #D0D5DD",
    maxHeight: 70,
    borderRadius: 10,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    padding: "16px 20px",
    marginBottom: 20,
    marginTop: 15
  },
  picker: {
    opacity: 0,
    width: "100%",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    height: "100%",
    cursor: "pointer",
    position: "absolute"
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  uploadflex: {
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  uploadicon: {
    fontSize: 16,
    color: "#101928"
  },
  uploadtitle: {
    fontSize: 16,
    color: "#101928",
    marginBottom: 0,
    marginTop: 0
  },
  uploadsubtitle: {
    color: "#98A2B3",
    fontsize: 16,
    marginBottom: 0,
    marginTop: 0
  },
  remove: {
    color: "red",
    position: "relative",
    alignItems: "center",
    gap: 4,
    padding: "6px 8px",
    boxSizing: "border-box",
    marginLeft: 3,
    zIndex: 50,
    backgroundColor: "white",
    border: "1px solid #98A2B3",
    borderRadius: 4,
    display: "flex",
    fontWeight: "bold"
  },
  eventdetailsheader: {
    height: 200,
    width: "100%",
    overflow: "hidden",
    borderRadius: "8px 8px 0px 0px",
    position: "relative"
  },
  libcardcont: {
    position: "relative",
    maxWidth: "475px",
    height: "290px",
    borderRadius: "12px",
    border: "1px solid #EDEDF2",
    textDecoration: "none"
  },
  imageheader: {
    "& img": {
      width: "100%",
      borderRadius: "12px 12px 0px 0px"
    }
  },
  liblink: {
    textDecoration: "none"
  },
  libcard: {
    padding: "16px",
    "& h6": {
      fontWeight: "700",
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "left",
      textDecoration: "none"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "16px",
      height: "50px",
      maxWidth: "405px",
      marginBlock: "8px",
      textAlign: "left",
      textDecoration: "none"
    },
    "& a": {
      fontWeight: "500",
      fontSize: "16px",
      color: "#0A17A7",
      textAlign: "left !important",
      textDecoration: "none"
    }
  },
  loweritems: {
    height: "50px"
  },
  notfound: {
    maxWidth: "300px",
    paddingBottom: "50px",
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "30vh"
  },
  notificationheader: {
    padding: "16px",
    backgroundColor: "#F5F6F7",
    border: "1px solid #E4E7EC",
    borderRadius: "12px 12px 0px 0px",
    textAlign: "left",
    height: "102px",
    maxWidth: "650px",
    "& h3": {
      fontWeight: 700,
      fontSize: 16,
      color: "#101928",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: 14,
      color: "#455367",
      marginBlock: "0px"
    }
  },
  notificationhead: {
    padding: "16px",
    backgroundColor: "#F5F6F7",
    border: "1px solid #E4E7EC",
    borderRadius: "12px 12px 0px 0px",
    textAlign: "left",
    height: "102px",
    maxWidth: "650px",
    "& h3": {
      fontWeight: 700,
      fontSize: 16,
      color: "#101928",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: 14,
      color: "#455367",
      marginBlock: "0px"
    }
  },
  notificationcontent: {
    padding: "24px 16px",
    border: "1px solid #E4E7EC",
    borderRadius: "0px 0px 12px 12px",
    textAlign: "left",
    height: "92px",
    maxWidth: "650px",
    "& h4": {
      fontWeight: 700,
      fontSize: 16,
      color: "#1D2739"
    },
    "& p": {
      marginBlock: "0px",
      color: "#475367",
      fontSize: 14
    },
    "& h6": {
      fontWeight: 400,
      fontSize: 14,
      color: "#101928",
      marginBlock: 0
    }
  },
  notificationcontents: {
    padding: "24px 16px",
    border: "1px solid #E4E7EC",
    borderRadius: "0px 0px 12px 12px",
    textAlign: "left",
    height: "92px",
    maxWidth: "650px",
    "& h4": {
      fontWeight: 700,
      fontSize: 16,
      color: "#1D2739"
    },
    "& p": {
      marginBlock: "0px",
      color: "#475367",
      fontSize: 14
    },
    "& h6": {
      fontWeight: 400,
      fontSize: 14,
      color: "#101928",
      marginBlock: 0
    }
  },
  flexresponsive: {
    flex: "0 0 75%"
  },
  viewmore: {
    "& p": {
      color: "#0065FF !important",
      fontSize: "12px !important",
      cursor: "pointer"
    }
  },
  mainWrapper: {
    display: "flex",
    height: "calc(100vh - 200px)",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "10px",
    overflow: "hidden",
    background: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 180px)",
      flexDirection: "column",
      border: "none",
      borderRadius: "0"
    }
  },
  leftPanel: {
    width: "350px",
    borderRight: `1px solid ${theme.palette.divider}`,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    background: theme.palette.background.paper,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      borderRight: "none",
      height: "100%"
    }
  },
  rightPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 100,
      background: theme.palette.background.paper
    }
  },
  rightPanelEmpty: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "inherit",
    height: "100%",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 100,
      background: theme.palette.background.paper
    }
  },

  tabContainer: {
    display: "flex",
    margin: "16px 0",
    width: "100%",
    gap: "5px",
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto !important",
      paddingBottom: "8px",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      msOverflowStyle: "none",
      scrollbarWidth: "none"
    }
  },
  tabButton: {
    textTransform: "none !important",
    fontWeight: "400 !important",
    fontSize: "14px",
    padding: "6px 18px !important",
    background: "white !important",
    color: "#545962 !important",
    borderRadius: "5px",
    flexShrink: 0,
    minWidth: "auto !important",
    "&:hover": {
      background: `${tinycolor(theme.palette.primary.main).lighten(20).setAlpha(0.1).toRgbString()} !important`
    }
  },
  tabButtonSelected: {
    backgroundColor: `${tinycolor(theme.palette.primary.main).lighten(20).setAlpha(0.1).toRgbString()} !important`,
    color: "black !important",
    fontWeight: "500 !important"

  },
  tabCount: {
    marginLeft: "8px",
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.secondary,
    borderRadius: "10px",
    padding: "0 8px",
    fontSize: "12px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500
  },
  tabCountSelected: {
    backgroundColor: theme.palette.primary.main,
    color: "white"
  },
  // Left panel sections
  searchWrapper: {
    padding: "5px 15px",
    [theme.breakpoints.down("sm")]: {
      padding: "5px 12px"
    }
  },
  actionIconRow: {
    padding: "12px 16px",
    paddingTop: 0,
    display: "flex",
    gap: "24px",
    alignItems: "center",
    color: theme.palette.text.secondary,
    fontSize: "22px",
    "& .iconify": {
      cursor: "pointer",
      "&:hover": {
        color: theme.palette.text.primary
      }
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  actionIconDots: {
    marginLeft: "auto"
  },
  notificationListWrapper: {
    flex: 1,
    overflowY: "auto"
  },

  // List Item Styles
  notificationItem: {
    display: "flex",
    alignItems: "flex-start",
    textAlign: "left",
    padding: "16px 12px",
    margin: "0 15px",
    marginTop: "5px",
    cursor: "pointer",
    backgroundColor: theme.palette.background.paper,
    transition: "background-color 0.2s",
    color: "#8A93A3",
    "&:hover": {
      backgroundColor: tinycolor(theme.palette.primary.main).lighten(20).setAlpha(0.1).toRgbString()
    }
  },
  notificationItemRead: {
    "& $notifyTitle": {
      color: "#8A93A3",
      fontWeight: "400"
    },
    "& $notifySubject": {
      color: "#8A93A3",
      fontWeight: "400"
    },
    "& $notifyMessage": {
      color: "#8A93A3"
    }
  },
  notificationItemUnread: {
    borderRadius: "8px"
  },
  notificationItemSelected: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(20).setAlpha(0.1).toRgbString(),
    "& $notifyTitle": {
      color: theme.palette.text.primary,
      fontWeight: 600
    },
    "& $notifySubject": {
      color: theme.palette.primary.main,
      fontWeight: 400
    },
    "& $notifyMessage": {
      color: theme.palette.text.secondary
    }
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "#FFECE5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    color: "#101928",
    marginRight: 12,
    flexShrink: 0,
    fontSize: 14
  },
  notificationItemMain: {
    flex: 1,
    minWidth: 0 // Prevents overflow
  },
  notifyTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  notifySubject: {
    fontSize: 14,
    color: theme.palette.primary.main,
    fontWeight: 400,
    margin: "2px 0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  notifyMessage: {
    color: theme.palette.text.secondary,
    fontSize: "13px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  notificationItemRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginLeft: 10
  },
  notifyTime: {
    color: theme.palette.text.disabled,
    fontSize: "12px"
  },
  unreadDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    display: "inline-block",
    marginTop: 12
  },

  // === Mobile Detail View ===
  rightPanelHeaderMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    cursor: "pointer",
    "& .iconify": {
      fontSize: "24px",
      marginRight: 8
    }
  },
  notifMobileHeaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.8rem"
  },
  detailHeaderMobileOptions: {
    fontSize: 24,
    color: theme.palette.text.secondary,
    cursor: "pointer"
  },
  detailBodyMobile: {
    padding: "20px 0px"
  },
  detailBodyMobileSubject: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "15px 1rem",
    textAlign: "left",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& > h2": {
      fontSize: 18,
      fontWeight: 400,
      lineHeight: 1.3

    }
  },
  detailBodyMobileContent: {
    lineHeight: 1.7,
    color: theme.palette.text.primary,
    textAlign: "left",
    margin: "15px 1rem",
    padding: "20px",
    background: "#F9F9F9",
    fontSize: "14px",
    "& > p": {
      margin: "10px 0",
      fontSize: "14px"
    },
    "& a": {
      textDecoration: "underline",
      color: "black"

    }
  },
  detailFooter: {
    padding: "15px",
    margin: "10px 2rem",
    borderTop: `1px solid ${theme.palette.divider}`,
    textAlign: "center",
    backgroundColor: "#fcfcfc",
    paddingTop: 0
  },
  detailFooterText: {
    fontSize: 16,
    marginBottom: 20,
    paddingTop: "24px",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    justifyContent: "center",
    borderTop: `1px solid ${theme.palette.divider}`,
    "& img": {
      width: "5rem"
    },
    "@media (max-width: 600px)": {
      gap: "1rem",

      "& img": {
        width: "3.5rem"
      }
    }
  },
  socialIconsWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    padding: "24px"
  },
  socialWrapper: {
    background: "#F5F6F7",
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  socialIcon: {
    fontSize: 24,
    color: theme.palette.text.primary,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.text.primary
    }
  },

  // === DESKTOP STYLES ===
  detailBody: {
    paddingBottom: "20px"
  },
  detailBodyContent: {
    lineHeight: 1.7,
    color: theme.palette.text.primary,
    textAlign: "left",
    margin: "15px 2rem",
    padding: "24px",
    background: "#F9F9F9",
    fontSize: "16px",
    "& > p": {
      margin: "10px 0",
      fontSize: "16px"
    },
    "& a": {
      textDecoration: "underline",
      color: "black"

    }
  },
  detailBodySubject: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "15px 2rem",
    textAlign: "left",
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& > h2": {
      fontSize: 22,
      fontWeight: 400,
      lineHeight: 1.3

    }
  },
  notifHeaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1.5rem"
  },
  notifleft: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  notifAvatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "#FFECE5",
    color: "#002147",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 600,
    fontSize: 16
  },

  notifUserInfo: {
    marginLeft: 8,
    flex: 1,
    minWidth: 0,
    textAlign: "left"
  },

  notifFrom: {
    fontWeight: 400,
    fontSize: 16
  },

  notifTo: {
    fontSize: 12,
    color: "black",
    fontWeight: 400
  },

  notifDate: {
    fontSize: 12,
    color: "#777",
    marginLeft: 8,
    gap: "1rem",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center"
  },
  securitySection: {
    margin: "0 2rem",
    color: "#374151",
    fontSize: "16px",
    lineHeight: "1.6",
    textAlign: "left"
  },
  securityMobileSection: {
    marginTop: "32px",
    margin: "0 2rem",
    color: "#374151",
    fontSize: "16px",
    lineHeight: "1.6",
    textAlign: "left"
  },
  securityLink: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  },

  teamSignature: {
    marginTop: "20px",
    color: "#4B5563"
  },
  customMenu: {
    marginTop: "8px",
    "& .MuiPaper-root": {
      borderRadius: "12px",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
      border: "1px solid #E5E7EB",
      minWidth: "120px"
    },
    "& .MuiList-root": {
      padding: "8px"
    }
  },

  customMenuItem: {
    fontSize: "14px",
    color: "#1F2937",
    borderRadius: "8px",
    padding: "10px 16px",
    fontWeight: 500,
    marginBottom: "2px",
    display: "flex",
    justifyContent: "space-between",
    "&:hover": {
      backgroundColor: tinycolor(theme.palette.primary.main).lighten(20).setAlpha(0.1).toRgbString()
    }
  },

  menuBadge: {
    backgroundColor: "#F3F4F6",
    color: "#4B5563",
    borderRadius: "12px",
    padding: "2px 8px",
    fontSize: "12px",
    fontWeight: 600,
    marginLeft: "8px"
  }
}));
